const GLOBAL_SOUND_PREF_KEY = 'game:sound-enabled';
const LEGACY_SOUND_PREF_KEYS = [
  'game:sound-enabled',
  'chess:sound-enabled',
  'whot:sound-enabled',
];
const SOUND_PREF_EVENT = 'wikigame:sound-preference-changed';

export function getGlobalSoundEnabled() {
  if (typeof window === 'undefined') return true;

  for (const key of LEGACY_SOUND_PREF_KEYS) {
    const stored = window.localStorage.getItem(key);
    if (stored != null) {
      return stored !== '0';
    }
  }

  return true;
}

export function setGlobalSoundEnabled(enabled) {
  if (typeof window === 'undefined') return;
  const nextValue = enabled ? '1' : '0';

  LEGACY_SOUND_PREF_KEYS.forEach((key) => {
    window.localStorage.setItem(key, nextValue);
  });

  window.dispatchEvent(new CustomEvent(SOUND_PREF_EVENT, {
    detail: { enabled: Boolean(enabled) },
  }));
}

export function subscribeToGlobalSoundPreference(callback) {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {};
  }

  const handleStorage = (event) => {
    if (!event?.key || !LEGACY_SOUND_PREF_KEYS.includes(event.key)) return;
    callback(getGlobalSoundEnabled());
  };

  const handleCustom = (event) => {
    callback(Boolean(event?.detail?.enabled));
  };

  window.addEventListener('storage', handleStorage);
  window.addEventListener(SOUND_PREF_EVENT, handleCustom);

  return () => {
    window.removeEventListener('storage', handleStorage);
    window.removeEventListener(SOUND_PREF_EVENT, handleCustom);
  };
}

export { GLOBAL_SOUND_PREF_KEY, SOUND_PREF_EVENT };
